export const SUMMARY_REPORT = {
  Summary: '/report/summary',
  ExportSummary: '/report/summary/export',
  Details: '/report/summary/details',
  ExportDetails: '/report/summary/export-details',
};
